var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.courseAbsenceList && _vm.courseAbsenceList.length)?_c('div',[_c('b-table',{staticClass:"mb-5 table-dropdown no-scrollbar border rounded",attrs:{"empty-text":this.$t('there_are_no_records'),"bordered":"","striped":"","responsive":"","items":_vm.absenceItems,"fields":_vm.absenceFields,"show-empty":""}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }